import { Component, input, computed } from '@angular/core';
import { ProgressBarComponent } from '../progress-bar/progress-bar.component';

@Component({
  selector: 'app-sidenav-processing-overlay',
  templateUrl: './sidenav-processing-overlay.component.html',
  styleUrls: ['./sidenav-processing-overlay.component.scss'],
  imports: [ProgressBarComponent]
})
export class SidenavProcessingOverlayComponent {
  visible = input<boolean>(false);
  progress = input<number | null>(null);
  statusText = input<string>('Processing…');

  isIndeterminate = computed(() => this.progress() === null);
  progressValue = computed(() => this.progress() ?? 0);
}
